import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { warn as _warn } from "@instructure/console";
export var createThemeAdapter = function createThemeAdapter() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      _ref$map = _ref.map,
      map = _ref$map === void 0 ? {} : _ref$map,
      version = _ref.version;

  return function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
        _ref2$theme = _ref2.theme,
        theme = _ref2$theme === void 0 ? {} : _ref2$theme,
        displayName = _ref2.displayName;

    return Object.entries(theme).reduce(function (result, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      if (map[key]) {
        /*#__PURE__*/

        /*#__PURE__*/
        _warn(false, "[".concat(displayName, "] The theme variable `").concat(key, "` has been changed to `").concat(map[key], "`.").concat(version ? " In version ".concat(version, ", `").concat(key, "` will no longer work as an override. Use `").concat(map[key], "` instead.") : ''));

        return _objectSpread({}, result, _defineProperty({}, map[key], value));
      }

      return _objectSpread({}, result, _defineProperty({}, key, value));
    }, {});
  };
};